import clsx from 'clsx';
import Link from 'next/link';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Card, { CardContent, CardMedia } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import Props from '@/components/shared/components/search/suggests/product/type';

import localization from '@/constant/localization';

export default function Product({ linkId, slug, icon, title, saleAmount, className }: Props) {
  return (
    <Card center className='h-[78px] justify-center rounded-lg bg-[#F7F8F9]' noBorder noShadow>
      <Link id={linkId} className={className} href={`/web/${slug}`} prefetch={false}>
        <CardContent center className={clsx('justify-start gap-2 px-[10px] pt-2.5 pb-2.5')}>
          <CardMedia
            src={icon.publicLink}
            alt={icon.title}
            width={50}
            height={50}
            className='rounded-[10px]'
          />
          <Container>
            <Text size={SIZE_ENUM.XS} className='line-clamp-2 pt-2.5 leading-5 text-[#5B5C60]'>
              {title}
            </Text>
            <Text className='pt-0.5 text-[13px] text-[#86878E]'>
              {saleAmount} {localization.sale}
            </Text>
          </Container>
        </CardContent>
      </Link>
    </Card>
  );
}
